import { useState } from 'react';
import { Info } from 'lucide-react';

interface HelpTooltipProps {
  helpText?: string;
  className?: string;
}

export function HelpTooltip({ helpText, className = '' }: HelpTooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  if (!helpText) return null;

  return (
    <div className={`relative inline-block ${className}`}>
      <div
        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-gray-200 hover:bg-gray-300 cursor-help transition-colors duration-200"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        <Info className="w-3 h-3 text-gray-600" />
      </div>
      
      {isVisible && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-5 py-3 bg-gray-900 text-white text-sm rounded-lg shadow-lg z-50 min-w-80 max-w-md">
          <div className="whitespace-normal leading-relaxed text-left">{helpText}</div>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
        </div>
      )}
    </div>
  );
}
